import React from 'react';
import { CTAButton } from './CTAButton';
const esiIncludes = ['Megapack ESI Secundaria · 25 temas', 'BONUS 1: Banco de Producciones Escritas', 'BONUS 2: Banco de Debates para Secundaria', 'BONUS 3: 50 Actividades de Ciudadanía', 'BONUS 4: Del Aula al Mundo', 'Acceso inmediato y de por vida'];
export function PurchaseSection() {
  return <section id="compra" className="py-8 px-4 bg-black text-white text-center" data-id="element-271" data-mp="2w696jfpgbiuy">
      <div className="max-w-4xl mx-auto" data-id="element-272" data-mp="3a2cw2vpdr313">
        <h2 className="text-[20px] font-black mb-6 text-[#9D7FE0]" data-id="element-273" data-mp="3554b6ncukkw5">
          ACCEDÉ AHORA A MEGAPACK ESI SECUNDARIA
        </h2>

        <div className="max-w-2xl mx-auto" data-id="element-274" data-mp="3jspccbq5wa1f">
          <div className="bg-gray-900 p-5 md:p-8 rounded-3xl border-2 border-gray-800 shadow-2xl" data-id="element-275" data-mp="3jvts86czou7x">
            <h3 className="text-3xl md:text-4xl font-black text-white mb-1" data-id="element-276" data-mp="3ewqs90bv9e6t">
              Megapack ESI Secundaria
            </h3>
            <p className="text-lg md:text-xl font-bold text-[#9D7FE0] mb-1" data-id="element-277" data-mp="3otddvrc0o99w">
              25 temas + los 4 bonus
            </p>
            <p className="text-base text-gray-400 mb-5" data-id="element-278" data-mp="y76hrkd2s7jo">
              Todo lo que necesitás para trabajar ESI durante el año
            </p>

            <div className="flex justify-center mb-6" data-id="element-279" data-mp="1299uecbhdi6j">
              <div className="h-44 md:h-56 flex items-center justify-center" data-id="element-280" data-mp="175rz5c6t9giv">
                <img src="https://cdn.magicpatterns.com/uploads/pRtZ4NNJpC3vWeMef8iJXA/ChatGPT_Image_29_jun_2026,_12_28_03_a.m._-_Editado.png" alt="Megapack ESI Secundaria + Todos los bonus" className="max-h-full max-w-full object-contain drop-shadow-2xl" data-id="element-281" data-mp="1c5wegyvzg57i" />
              </div>
            </div>

            <ul className="text-left space-y-2 mb-6 max-w-md mx-auto text-base md:text-lg text-gray-200" data-id="element-282" data-mp="1uw4eh84dyfjh">
              {esiIncludes.map(item => <li key={item} className="flex items-start" data-id="element-283" data-mp="1zwiatswmk11o">
                  <span className="text-[#9D7FE0] mr-2 font-bold flex-shrink-0" data-id="element-284" data-mp="24u1z7ln1du7c">
                    ✔
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mb-5" data-id="element-285" data-mp="1a7lbsiy5yddz">
              <p className="text-gray-400 text-sm uppercase tracking-widest font-bold mb-1" data-id="element-286" data-mp="1a8mo0qqx15xa">
                Precio único
              </p>
              <p className="text-5xl md:text-6xl font-black text-white" data-id="element-287" data-mp="1k5983dbf3sy9">
                ARS $19.990
              </p>
              <p className="text-sm text-gray-400 mt-1" data-id="element-288" data-mp="1xw4k2yh7qq62">
                Pago único · Acceso de por vida
              </p>
            </div>

            <CTAButton href="https://checkout.aula-mater.online/cart/66941603479597:1" className="w-full text-xl md:text-2xl py-6 flex items-center justify-center gap-3" data-id="element-289" data-mp="1sx1dh9ll4bvz">
              👉 LO QUIERO
            </CTAButton>
          </div>

          <div className="flex flex-col md:flex-row flex-wrap justify-center items-center gap-x-5 gap-y-2 text-sm md:text-base font-bold text-gray-300 mt-6" data-id="element-290" data-mp="dhu6dooc35te">
            <span className="flex items-center" data-id="element-291" data-mp="2k52xcup756z3">
              <span className="text-green-500 mr-2" data-id="element-292" data-mp="2k6dzkq2zu6o3">✔</span> Secundaria
            </span>
            <span className="flex items-center" data-id="element-293" data-mp="2p34hliyczcc5">
              <span className="text-green-500 mr-2" data-id="element-294" data-mp="2p5yzb2pzmj1v">✔</span> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-295" data-mp="2adfc5bj8gm62">
              <span className="text-green-500 mr-2" data-id="element-296" data-mp="2fdb5mgub0v7d">✔</span> Descarga digital
            </span>
            <span className="flex items-center" data-id="element-297" data-mp="21ebpjxkuxomt">
              <span className="text-green-500 mr-2" data-id="element-298" data-mp="21go564357mwp">✔</span> 25 temas
              fundamentales de ESI
            </span>
            <span className="flex items-center" data-id="element-299" data-mp="1rgnjwclpqwpv">
              <span className="text-green-500 mr-2" data-id="element-300" data-mp="1rhynocf5s4gz">✔</span> Recursos para todo
              el ciclo lectivo
            </span>
          </div>
        </div>
      </div>
    </section>;
}